import React from "react";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 2,
    color: theme.palette.getContrastText(theme.palette.background.paper),
    backgroundColor: "rgba(15, 23, 42, 0.42)"
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: 12,
    padding: theme.spacing(3),
    minWidth: 280,
    maxWidth: 420,
    border: `1px solid ${theme.custom?.border || "rgba(15, 23, 42, 0.12)"}`
  },
  progress: {
    width: "100%",
    marginTop: theme.spacing(0.5)
  },
  details: {
    textAlign: "center"
  }
}));

const BackdropLoading = ({
  open = true,
  message,
  details,
  progress = null
}) => {
  const classes = useStyles();
  const shouldRenderDetails = Boolean(message || details || progress !== null);

  return (
    <Backdrop className={classes.backdrop} open={open}>
      {shouldRenderDetails ? (
        <Box className={classes.content}>
          <CircularProgress color="inherit" />
          {message && <Typography variant="h6">{message}</Typography>}
          {details && (
            <Typography variant="body2" className={classes.details}>
              {details}
            </Typography>
          )}
          {progress !== null && (
            <Box className={classes.progress}>
              <LinearProgress
                variant="determinate"
                value={Number(progress) || 0}
              />
              <Typography variant="caption">{`${progress}%`}</Typography>
            </Box>
          )}
        </Box>
      ) : (
        <CircularProgress color="inherit" />
      )}
    </Backdrop>
  );
};

export default BackdropLoading;
